var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWelcome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_7107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.04507 52.861C0.825925 56.4357 0.354363 60.6987 0 63.9985L7.95908 59.6768L11.9591 52.0394L11.5513 48.6709L7.33775 47.418C6.70048 47.5875 6.08846 47.8407 5.51765 48.171C3.58312 49.2901 2.7714 50.7311 2.04507 52.861Z",
    fill: "#FFD845"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1373 61.9531C13.2704 61.2256 14.7093 60.4127 15.8274 58.4805C16.1577 57.9097 16.4109 57.2978 16.5804 56.6605L15.8304 52.7366L11.9589 52.0391L0 63.9982C2.02042 63.7812 7.09128 63.3329 11.1373 61.9531Z",
    fill: "#FFB454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3816 40.3292L11.5514 38.4619L4.9668 45.0463L11.9592 52.0389L17.2977 50.4519L18.5439 45.4544L17.3816 40.3292Z",
    fill: "#565686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5072 47.4182L18.5436 45.4551L11.959 52.0396L18.9514 59.0322L25.5361 52.4476L24.5072 47.4182Z",
    fill: "#454572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1376 40.497L30.04 51.2698V62.2517C31.5644 62.2371 32.3883 62.2957 33.8125 62.1639C44.7882 61.1491 52.675 51.4308 52.675 40.5876V34.7305L42.1376 40.497Z",
    fill: "#2EBEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2676 11.3232H23.4104C12.5225 11.3232 2.84532 19.2496 1.83417 30.1857C1.70251 31.6097 1.76098 32.4329 1.74639 33.9582H12.7283C25.5406 19.2269 22.6717 22.5257 23.082 22.054L29.2676 11.3232Z",
    fill: "#00E4EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.027 2.78711C28.8805 8.33029 14.7848 22.038 11.5513 38.4622L18.5437 45.4547L36.5847 31.4978L50.1023 13.8961L48.6834 6.70233L45.027 2.78711Z",
    fill: "#F9F2F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1019 13.8965L18.5435 45.455L25.5359 52.4475C33.8585 50.8091 41.4634 46.3972 47.6655 40.3546C53.75 34.4265 58.4842 26.9292 61.2211 18.9419L57.0777 15.5376L50.1019 13.8965Z",
    fill: "#ECEAE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1387 19.1949C31.1923 22.1413 31.1853 26.9067 34.1387 29.8602L40.8545 25.9108L44.8038 19.195C41.861 16.252 37.0957 16.2379 34.1387 19.1949Z",
    fill: "#565686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1387 29.8597C37.0816 32.8026 41.8469 32.8166 44.8038 29.8597C47.7502 26.9132 47.7571 22.1478 44.8038 19.1943C43.5136 20.4848 35.4377 28.5607 34.1387 29.8597Z",
    fill: "#454572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9926 0.00594307C63.0218 0.0740995 59.4978 -0.226694 54.3792 0.51523C51.6629 0.908827 48.4978 1.59605 45.0269 2.78753C45.3474 3.84433 45.3592 9.15361 50.102 13.8965L58.5433 8.47318L63.9926 0.00594307Z",
    fill: "#FF8659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1021 13.8964C54.7428 18.5371 60.4925 18.7237 61.2214 18.9419C62.4133 15.4626 63.0998 12.3071 63.4919 9.60447C64.2334 4.49274 63.9231 1.00142 63.9926 0.00585938L50.1021 13.8964Z",
    fill: "#FF405C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8054 21.8611C35.3327 23.3337 35.3283 25.7167 36.8054 27.1937L40.8549 25.9106L42.1379 21.8611C40.6664 20.3897 38.2837 20.3826 36.8054 21.8611Z",
    fill: "#00E4EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8052 27.193C38.2746 28.6623 40.6568 28.6739 42.1377 27.193C43.6101 25.7205 43.615 23.3377 42.1377 21.8604L36.8052 27.193Z",
    fill: "#2EBEEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_7107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/welcome.e95304623833982393ecef0e0cfdfec9.svg";
export { ForwardRef as ReactComponent };